module.exports = __webpack_public_path__ + "static/genceMMS-2a36ca21047ea1ee01e1e6f52e231bb8.png";